<article class="main__profile--container" [zipBusy]="busy">
  <main class="main__profile">
    <header class="main__profile__header">
      <div class="main__profile__breadcrumb" (click)="onViewAllResultsClick()">
        <i class="icon icon--medium icon--link" data-test-id="profileBackIcon"
          >chevron_left</i
        >
        <p class="t-data t-bold t-link" data-test-id="profileBackText">
          Back to All Search Results
        </p>
      </div>

      <div class="main__profile__navigation">
        <p
          class="t-data"
          [ngClass]="{
            't-alt': selectedResultIdx === 0,
            't-bold t-link': selectedResultIdx !== 0,
          }"
          data-test-id="previousProviderProfileText"
          (click)="
            selectedResultIdx !== 0 &&
              onPreviousNextClick(selectedResultIdx - 1)
          "
        >
          Previous
        </p>

        <p
          class="t-data"
          [ngClass]="{
            't-alt': selectedResultIdx === backendResults.length - 1,
            't-bold t-link': selectedResultIdx !== backendResults.length - 1,
          }"
          data-test-id="nextProviderProfileText"
          (click)="
            selectedResultIdx !== backendResults.length - 1 &&
              onPreviousNextClick(selectedResultIdx + 1)
          "
        >
          Next
        </p>
      </div>
    </header>

    @if (!!showDetails) {
      <div class="u-flex">
        <section class="main__profile__info">
          <section id="pcp__profile__id" class="main__profile__info__section">
            @if (!removePCPavatar) {
              <div class="main__profile__id">
                <div class="avatar main__profile__avatar">
                  <img
                    src="{{ selectedResult.picture }}"
                    alt="Selected result"
                    data-test-id="selectedProviderImg"
                  />
                </div>
                <p
                  class="t-data"
                  data-test-id="selectedProviderGender"
                  [innerHTML]="selectedResult.gender | titlecase"
                ></p>
              </div>
            }
            <div class="search__result__section__content">
              <h5 class="t-bold" data-test-id="selectedProviderName">
                {{ selectedResult | fullName: true }}, MD
              </h5>
              <p class="t-data t-bold" data-test-id="selectedProviderSpecialty">
                {{ selectedResult.primary_specialty }}
              </p>
              <div class="main__profile__attributes">
                @if (!!selectedResult.accepting_new_patients) {
                  <div class="main__profile__attribute">
                    <i class="icon" data-test-id="selectedProviderCheckIcon"
                      >check</i
                    >
                    <div>
                      <span data-test-id="selectedProviderAcceptingPatientText"
                        >Accepting New Patients</span
                      >
                      @if (removePCPavatar) {
                        <p
                          class="t-data"
                          data-test-id="selectedProviderAcceptingPatientGender"
                          [innerHTML]="selectedResult.gender | titlecase"
                        ></p>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </section>
          <section class="main__profile__info__section">
            <h5 class="t-bold" data-test-id="selectedProviderContactHeader">
              Contact
            </h5>
            <div class="model-attributes">
              @for (
                contactConfig of contactConfigs;
                track contactConfig;
                let i = $index
              ) {
                <model-attribute
                  [context]="contactContext"
                  [config]="contactConfig.config"
                  (linkClicked)="onDirectionsLinkClick($event)"
                  direction="column"
                  [data-test-id]="'providerContactDetail_' + i"
                >
                </model-attribute>
              }
            </div>
          </section>
          <section class="main__profile__info__section">
            <h5 class="t-bold" data-test-id="selectedProviderProfileHeader">
              Profile
            </h5>
            <div class="model-attributes">
              @for (
                profileConfig of profileConfigs;
                track profileConfig;
                let i = $index
              ) {
                @if (!!shouldShowModelAttribute(profileConfig.config.prop)) {
                  <model-attribute
                    [context]="profileContext"
                    [config]="profileConfig.config"
                    direction="column"
                    [data-test-id]="'providerProfileDetail_' + i"
                  >
                  </model-attribute>
                }
              }
            </div>
          </section>
          <section class="main__profile__info__section">
            <h5 class="t-bold" data-test-id="selectedProviderEducationHeader">
              Education and Training
            </h5>
            <div class="model-attributes">
              @for (
                eduAndTrainConfig of educationAndTrainingConfigs;
                track eduAndTrainConfig;
                let i = $index
              ) {
                @if (
                  !!shouldShowModelAttribute(eduAndTrainConfig.config.prop)
                ) {
                  <model-attribute
                    [context]="educationAndTrainingContext"
                    [config]="eduAndTrainConfig.config"
                    direction="column"
                    [data-test-id]="'providerEducationDetail_' + i"
                  >
                  </model-attribute>
                }
              }
            </div>
          </section>
        </section>
        <aside class="main__profile__aside">
          @if (!selectedResult.selected) {
            <zip-button
              size="full"
              level="high"
              content="Add Provider"
              [disabled]="resultIsSelected"
              (zipButtonClicked)="onAddProviderClick()"
              data-test-id="addProviderButton"
            >
            </zip-button>
          }
          @if (selectedResult.selected) {
            <zip-button
              size="full"
              level="high"
              content="Selected"
              icon="check"
              (zipButtonClicked)="onRemoveProviderClick()"
              data-test-id="selectedProviderButton"
            >
            </zip-button>
          }
          <div class="main__profile__actions">
            <a
              class="main__profile__action"
              [href]="'tel: ' + selectedResult.phone"
            >
              <i
                class="icon icon--medium icon--link"
                data-test-id="providerPhoneIcon"
                >phone</i
              >
              <p class="t-data" data-test-id="providerPhoneText">
                Call Provider
              </p>
            </a>
            <a
              class="main__profile__action"
              target="_blank"
              [href]="selectedResultDirectionsUrl"
            >
              <i
                class="icon icon--medium icon--link"
                data-test-id="providerDirectionIcon"
                >directions</i
              >
              <p class="t-data" data-test-id="providerGetDirectionText">
                Get Directions
              </p>
            </a>
          </div>
        </aside>
      </div>
    }
  </main>

  <aside class="search__map">
    <div class="search__map__controls">
      <div class="search__map__control search__map__control--zoom">
        <i
          class="icon icon--medium icon--pointer"
          (click)="zoom = zoom + 1"
          data-test-id="mapZoomInIcon"
        >
          add
        </i>

        <i
          class="icon icon--medium icon--pointer"
          (click)="zoom = zoom - 1"
          data-test-id="mapZoomOutIcon"
        >
          subtract
        </i>
      </div>
    </div>

    <map
      [centerLat]="centerLat"
      [centerLng]="centerLng"
      [mapZoom]="zoom"
      [pins]="pins"
      (pin-selected)="onPinSelect($event)"
      data-test-id="providerMap"
    >
    </map>
  </aside>
</article>
